import { initialCommandState } from "@app/project/store/clarehome.state";
import { LoadingState } from "@app/root-store/api-result.state";
import { createReducer, on } from "@ngrx/store";
import { CommandActions } from "../actions";
import { CHCommandState } from "../rule.state";

export const commandReducer = createReducer(
    initialCommandState(),
    on(
        CommandActions.loadSet.request,
        (state, { uuid }): CHCommandState => ({
            ...state,
            uuid,
            callState: LoadingState.loading,
        })
    ),
    on(
        CommandActions.loadSet.success,
        (state, { uuid, commands }): CHCommandState => ({
            ...state,
            result: commands,
            uuid,
            callState: LoadingState.loaded,
        })
    ),
    on(CommandActions.clearCommandState, (): CHCommandState => initialCommandState())
);
